import React from 'react'
import { DatePicker } from 'react-md'

const CustomDatePicker = ({ input, meta: { touched, error, warning }, ...rest }) => {
  return (
    <DatePicker {...input} {...rest}
      error={touched && !!error}
      errorText={error}
      helpText={warning}
    />
  )
}

export default CustomDatePicker



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js